import {Image} from "@chakra-ui/react";
const Presentacion = () => {

    return(
       <Image borderRadius='xl' pos="relative" boxSize="2xs" src="../radio-logo.png" alt="Logo radio La Estación"/>
    )
}
export default Presentacion